
    export default {
      path: `/home/runner/work/fase2-website/fase2-website/src/components/pages/ueberuns/fachkompetenz/fachkompetenz-view.kpa`,
      template: `<section aria-labelledby="hero-headline" class="fachkompetenz-view">
        <hero-section
            background-image="/images/hero/fachkompetenz-hero.png"
            headline="Unsere Fachkompetenz"
            subheadline="Fachkompetenz mit FASE2"
            text="Wir bieten zuverlässigen, professionellen Service mit Leidenschaft."
            button-text2="Jetzt kostenlos beraten lassen!"
            button-link2="/home#kontakt"
        ></hero-section>

        <tool-bar></tool-bar>

        <div class="wrapper">
            <article aria-labelledby="geschichte-team">
                <hex-headline id="geschichte-team" left text="Unsere Geschichte & Das Team"></hex-headline>
                <p>
                    FASE2 ist das Ergebnis einer starken Partnerschaft zwischen zwei Fachleuten, die ihre Leidenschaft für Qualität und Effizienz vereint haben:
                </p>

                <div class="team">
                    <member-card
                    type="slaudani"
                        img="/images/team/s.laudani.png"
                        name="Salvatore Laudani"
                        beruf="Bauunternehmer"
                        spez="Sanierungsspezialist"
                        text="25 Jahre Erfahrung in der Baubranche"
                    ></member-card>

                    <member-card
                        type="hsidar"
                        img="/images/team/h.sidar.png"
                        name="Hüseyin Sidar"
                        beruf="Gebäudereiniger"
                        spez="Reinigungsspezialist"
                        text="13 Jahre Erfahrung in der Reinigungsbranche"
                    ></member-card>
                </div>
            </article>

            <article aria-labelledby="profil-laudani">
                <hex-headline id="profil-laudani" left text="Laudani GmbH"></hex-headline>
                <p>
                    Die <a href="https://www.laudani-gmbh.de/" target="_blank">Laudani GmbH</a> ist seit über 25 Jahren ein führender Anbieter für Immobiliensanierungen und Instandhaltungsarbeiten in Köln und Umgebung. 
                    Mit ihrem umfangreichen Know-how und der langjährigen Expertise im Bereich Gebäudesanierung hat sich die <a href="https://www.laudani-gmbh.de/" target="_blank">Laudani GmbH</a> einen exzellenten Ruf aufgebaut. 
                    Von der Komplettsanierung über Renovierungen bis hin zur Wartung und Pflege Ihrer Immobilie - bei der <a href="https://www.laudani-gmbh.de/" target="_blank">Laudani GmbH</a> erhalten Sie alles aus einer Hand. 
                </p>
            </article>

            <hr>

            <article aria-labelledby="profil-cleanodino">
                <hex-headline id="profil-cleanodino" left text="cleanodino"></hex-headline>
                <p>
                    Die <a href="https://cleanodino.de/" target="_blank">cleanodino</a> Gebäudereinigung setzt in Leverkusen und Umgebung neue Maßstäbe im Bereich der professionellen Gebäudereinigung. 
                    Mit einem Fokus auf nachhaltige Reinigungsprozesse, höchste Hygienestandards und einem Team von hochqualifizierten Reinigungskräften bieten wir erstklassige Dienstleistungen für Privatpersonen und Unternehmen. 
                    <a href="https://cleanodino.de/" target="_blank">cleanodino</a> sorgt dafür, dass Ihre Immobilie nicht nur sauber, sondern auch gepflegt und einladend bleibt.
                </p>
            </article>

            <hr>

            <article aria-labelledby="profil-der-cleanoshop">
                <hex-headline id="profil-der-cleanoshop" left text="Der Cleanoshop"></hex-headline>
                <p>
                    Mit dem "<a href="https://www.der-cleanoshop.de/" target="_blank">Der Cleanoshop</a>" Shop bieten wir Ihnen zudem alles, was Sie für eine professionelle Reinigung benötigen. 
                    Ob Reinigungsmittel, Ausrüstungen oder Zubehör – hier finden Sie eine große Auswahl an Produkten, die in der Gebäudereinigung und Sanierung verwendet werden. 
                    <a href="https://www.der-cleanoshop.de/" target="_blank">Der Cleanoshop</a> steht für hohe Qualität, Zuverlässigkeit und faire Preise. 
                </p>
            </article>

            <hr>

            <article aria-labelledby="mission-vision">
                <hex-headline id="mission-vision" left text="Unsere Mission und Vision"></hex-headline>
                <p>
                    Wir bei <b>FASE2</b> haben uns zum Ziel gesetzt, <b>Immobilien</b> nicht nur zu pflegen, sondern sie auch <b>nachhaltig</b> zu entwickeln. Unser Ansatz vereint <b>Qualität</b>, 
                    Zuverlässigkeit und <b>Wirtschaftlichkeit</b> - für eine sorgenfreie Immobilieninstandhaltung.
                </p>
                <ul>
                    <li><strong>Immobilien wirtschaftlich entwickeln und pflegen:</strong> Wir kombinieren bauliches Know-how mit präziser Reinigung, um den Wert Ihrer Immobilie zu steigern.</li>
                    <li><strong>Sorgenfreie Immobilieninstandhaltung:</strong> Unser Rundum-Service sorgt dafür, dass Sie sich entspannt zurücklehnen können, während wir uns um alle Details kümmern.</li>
                </ul>
            </article>

            <hr>

            <article aria-labelledby="warum-fase2">
                <hex-headline id="warum-fase2" left text="Warum FASE2?"></hex-headline>
                <ul>
                    <li>Über <b>38 Jahre kombinierte Erfahrung</b> in der <b>Baubranche</b> und <b>Gebäudereinigung</b></li>
                    <li>Maßgeschneiderte Lösungen für jede Immobilie</li>
                    <li>Partnerschaftlich, zuverlässig und professionell</li>
                </ul>
            </article>
        </div>
    </section>`,
      style: `fachkompetenz-view .fachkompetenz-view {
  margin: 0;
  padding: 0;
}
fachkompetenz-view .fachkompetenz-view .wrapper {
  max-width: 1440px;
  margin: 0 auto;
  padding: 64px 64px;
}
fachkompetenz-view .fachkompetenz-view .wrapper article {
  margin: 96px 0 0 0;
  padding: 0;
}
fachkompetenz-view .fachkompetenz-view .wrapper article:first-of-type {
  margin: 0 0 0 0;
}
fachkompetenz-view .fachkompetenz-view .wrapper article:nth-child(2) {
  margin: 32px 0 0 0;
}
fachkompetenz-view .fachkompetenz-view .wrapper aside {
  margin: 0 0 32px 0;
  padding: 0;
}
fachkompetenz-view .fachkompetenz-view .team {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-around;
  gap: 16px;
  padding: calc(64px - 1.2rem) 0 0 0;
}
@media (max-width: 992px) {
  fachkompetenz-view .fachkompetenz-view .wrapper {
    padding: 64px 32px;
  }
}`,
      script: `(async () => { "use strict";
return {
    data: {},
};
 })()`
    };
  